module.exports = __webpack_public_path__ + "img/04.07d09278.jpg";